import { Component, Input, forwardRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { PARAMS } from '../../../contants/PARAMS';
import { AlertService } from '../../../services/alert.service';
import { ParameterService } from '../../../services/parameter.service';

@Component({
  selector: 'ztsi-tabs-expense-select',
  templateUrl: './ztsi-tabs-expense-select.component.html',
  providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => ZtsiTabsExpenseSelectComponent),
			multi: true
		}
	]
})
export class ZtsiTabsExpenseSelectComponent implements ControlValueAccessor {
	options: number[] = [0, 336, 560];

	@Input('value') _value: string;
	@Input() isDisabled: boolean = false;

	onChange: any = () => { };
	onTouched: any = () => { };

	get value() {
		return this._value;
	}

	set value(val) {
		this._value = val;
		this.onChange(val);
		this.onTouched();
	}

	constructor(
		private _parameterService: ParameterService,
		private _alertService: AlertService
	) { }

	writeValue(value): void {
		if (value !== undefined) {
			this._value = value;
		}
	}

	registerOnChange(fn: any): void {
		this.onChange = fn;
	}

	registerOnTouched(fn: any): void {
		this.onTouched = fn;
	}

	ngOnInit() {
		this._parameterService.getCachedSystemParameterArray<string>(PARAMS.DAILY_TRIP_TABS_OPTION, 3600).subscribe(response => {
			if (response.length != undefined && response.length > 0) {
				this.options = response.map(x => parseInt(x));
				this.options.sort();
			}
			else {
				console.log('Unable to load expense type selection.');
			}
		});
	}
}



// WEBPACK FOOTER //
// ./src/app/components/shared/ztsi-tabs-expense-select/ztsi-tabs-expense-select.component.ts